import { Form, notification, Spin } from "antd";
import { FormComponentProps } from "antd/lib/form";
import DataGrid, { Column, FilterRow, HeaderFilter, Pager, Paging } from "devextreme-react/data-grid";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import { ServiceContext } from "src/services/provider/Service.provider";
import "./quote.scss";
import { IQuoteList } from "src/services/interfaces/trade/precificacao/IQuoteList";
import { formatCurrency } from "src/util/Masks/formatCurrency";

interface IAllQuotesTable {
  style?: React.CSSProperties;
  max?: number;
}

function AllQuotesTable(props: IAllQuotesTable & RouteComponentProps<any> & FormComponentProps) {
  const { quoteService } = useContext(ServiceContext);

  const [data, setData] = useState<IQuoteList[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchGrid()
  }, []);

  function fetchGrid() {
    setLoading(true);

    quoteService
      .getAllList()
      .then(resp => {
        let quotes = resp;
        if (props.max) {
          quotes = quotes.slice(0, props.max);
        }
        setData(quotes);
      })
      .catch(error => {
        notification.error({
          message: "Falha na consulta",
          description: "Ocorreu um erro durante a consulta. Tente novamente."
        });
      })
      .finally(() => setLoading(false));
  }

  return (
    <div className="quote">
      <Spin spinning={loading}>
        <PbrCard title={`Cotações`} bordered={false} style={{ width: "100%" }}>
          {data && (
            <DataGrid
              dataSource={data}
              allowColumnReordering
              showBorders
              loadPanel={{ enabled: loading }}
              rowAlternationEnabled
              hoverStateEnabled
              columnAutoWidth
            >
              <FilterRow visible />
              <HeaderFilter visible />

              <Column caption="ID" dataField="id" dataType="number" width={"100px"} alignment={"center"} />
              <Column caption="Usuário de criação" dataType="string" alignment={"center"} dataField="userLogin" />
              <Column caption="Escritório" dataType="string" dataField="officerName" alignment={"center"} />
              <Column caption="Status" dataType="string" dataField="status" alignment={"center"} />
              <Column caption="CPF/CNPJ" dataField="precatorioCpfCnpj" dataType="string" alignment={"center"} />
              <Column caption="Processo" dataField="precatorioProcessCode" dataType="string" alignment={"center"} />
              <Column caption="Principal" alignment={"center"} dataField="precatorioPrincipal" dataType="number" format="string"
                cellRender={params => {
                  return formatCurrency(params.data.precatorioPrincipal);
                }} />
              <Column caption="Juros" alignment={"center"} dataField="precatorioInterest" dataType="number" format="string"
                cellRender={params => {
                  return formatCurrency(params.data.precatorioInterest);
                }} />
              <Column caption="Processo Origem" dataField="precatorioProcessCodeSource" dataType="string" alignment={"center"} />
              <Column caption="Tribunal" dataField="precatorioCourt" dataType="string" alignment={"center"} />

              <Pager allowedPageSizes={[10, 25, 50, 100]} showPageSizeSelector />
              <Paging defaultPageSize={20} />
            </DataGrid>
          )}
        </PbrCard>
      </Spin>
    </div>
  );

}

export default withRouter(Form.create()(AllQuotesTable));



// WEBPACK FOOTER //
// ./src/pages/monitor/my-quotes/AllQuotesTable.tsx